export const UnableToInitiateStripeErrorMessage =
	"We are having troubles completing your booking. Please contact the clinic on (03) 9662 2256.";

export default class UnableToInitiateStripeError extends Error {
	constructor() {
		super(UnableToInitiateStripeErrorMessage);
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
